export default __webpack_public_path__ + "static/media/Asset 20.3781f5ea.png";